import { BLACKLIST_SOURCE_LABELS, formatBishkekTime, getBlacklistAuthor, getBlacklistStatusLabel } from '../constants';

const HEADER = ['Время (Бишкек)', 'Сеть', 'Адрес', 'Из', 'В', 'Кто', 'Источник', 'Комментарий', 'Клиентов'];

// Разделитель ; — значение с ; кавычками или переводом строки берём в кавычки
const escapeCell = (value) => {
  const text = value === null || value === undefined ? '' : String(value);
  return /[;"\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const toRow = (item) => [
  formatBishkekTime(item.at),
  item.network,
  item.address,
  getBlacklistStatusLabel(item.from_status),
  getBlacklistStatusLabel(item.to_status),
  getBlacklistAuthor(item.by, item.by_name),
  BLACKLIST_SOURCE_LABELS[item.source] || item.source,
  item.comment,
  item.users,
];

// items — все страницы «Истории» за период с фильтрами, их выкачивает вкладка.
// BOM нужен, чтобы Excel открыл кириллицу; start и end — даты запроса dd/mm/yyyy
export const downloadBlacklistCsv = (items, start, end) => {
  const lines = [HEADER, ...items.map(toRow)].map((row) => row.map(escapeCell).join(';'));
  const blob = new Blob([`﻿${lines.join('\r\n')}`], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `blacklist_${start.replace(/\//g, '.')}_${end.replace(/\//g, '.')}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
